/*
 * Public API Surface of core
 */

export * from './lib/core.service';
export * from './lib/core.component';
export * from './lib/core.module';
export * from './lib/services/version.service';
